
















































import { Component, Vue, Watch } from 'vue-property-decorator';

import { TForm } from '@/plugins/podolib/lib/types';
import { Doctor } from '@/plugins/podolib/services/doctor';

import CompositeCard from '@/components/composite/CompositeCard.vue';
import ElementCountryFlag from '@/components/elements/ElementCountryFlag.vue';
import { Severity } from '@sentry/types';

type TLang = {
  text: string;
  value: Doctor['config']['lang'];
  overrideFlag?: string;
  disabled?: boolean;
};

type TFields = {
  lang: {
    value: TLang['value'];
  };
};

@Component({
  components: { ElementCountryFlag, CompositeCard },
})
export default class SettingsLanguage extends Vue {
  langs: TLang[] = [
    {
      text: 'English',
      value: 'en',
    },
    /*{
        text: '中国',
        value: 'zh-CN',
        disabled: true
      },*/
    {
      text: 'Français',
      value: 'fr',
    },
    {
      text: 'Deutsch',
      value: 'de',
    },
    {
      text: 'Polish',
      value: 'pl',
    },
    {
      text: 'Italiano',
      value: 'it',
    },
    {
      text: 'ελληνικά',
      value: 'el',
      overrideFlag: 'gr',
    },
    {
      text: 'Español',
      value: 'es',
    },
  ];

  form: TForm<TFields> = {
    fields: {
      lang: {
        value: this.$store.getters['pdc/doctor/lang'],
      },
    },
    pending: false,
    error: null,
    success: false,
  };

  @Watch('form.fields.lang.value')
  onSelectedLangChange(newLang: TLang['value']) {
    this.save();
  }

  get doctor() {
    return this.$pdc.doctor!.current;
  }

  async save() {
    // Avoid duplication of the process
    if (this.form.pending) return;

    const lang = this.form.fields.lang.value;

    const previous = {
      lang: this.$store.getters['pdc/doctor/lang'],
    };

    try {
      // @ts-ignore
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      // Reset flags
      this.form.success = false;
      this.form.error = null;
      // Set 'pending' flag
      this.form.pending = true;
      // Try to patch the station ...
      await this.$pdc.repository!.patchRessource({
        ressource: 'doctors',
        params: { _id: this.doctor._id },
        data: {
          config: {
            lang,
          },
        },
      });
      // Analytics
      this.$pdc.analytics?.actions.trackSuccess(
        'User LanguageChanged',
        {
          lang,
        },
        previous,
      );
      this.form.success = true;
    } catch (e) {
      // Analytics
      this.$pdc.analytics?.actions.trackFailure(
        'User LanguageChanged',
        e,
        {
          lang,
        },
        previous,
      );
      // Revert the selected lang
      this.form.fields.lang.value = this.$store.getters['pdc/doctor/lang'];
      // Set 'error' flag
      this.form.error = e;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Error);
    } finally {
      // Reset 'pending' flag
      this.form.pending = false;
    }
  }
}
